export default __webpack_public_path__ + "KaTeX_SansSerif-Italic.c7feacd514ed1bf5669a9a4ee68fe99b.ttf";